import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    async function handleCallback() {
      try {
        // Let Supabase process the OAuth tokens from the URL hash
        const { data: { session }, error } = await supabase.auth.getSession()

        if (error || !session) {
          navigate('/login', { replace: true })
          return
        }

        const userId = session.user.id

        // Fetch profile and org in parallel
        const [{ data: profile }, { data: org }] = await Promise.all([
          supabase.from('profiles').select('role').eq('id', userId).maybeSingle(),
          supabase.from('organizations').select('id').eq('admin_id', userId).maybeSingle(),
        ])

        const role = profile?.role

        if (role === 'superadmin') {
          navigate('/superadmin', { replace: true })
        } else if (role === 'lecturer') {
          navigate('/lecturer', { replace: true })
        } else if (org) {
          // Existing org_admin with org → go to admin portal
          navigate('/admin', { replace: true })
        } else {
          // New user via Google — no org yet → finish setup on signup page
          navigate('/signup', { replace: true })
        }
      } catch {
        navigate('/login', { replace: true })
      }
    }

    handleCallback()
  }, [navigate])

  return (
    <div className="page-center">
      <div style={{ textAlign: 'center' }}>
        <span className="spinner" style={{ width: 32, height: 32, borderWidth: 3 }} />
        <p className="text-sm text-muted mt-3">Signing you in...</p>
      </div>
    </div>
  )
}
